module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/images/a80ee29864f0c982b8d1d0ae4580a3d1.svg";